import styled from "styled-components";

const Div = styled.div`
  width: 100%;
  display: flex;
`;

const Input = styled.input`
  width: 100%;
  height: 2.5rem;
  ::placeholder {
    color: #6c757da5;
  }
  :focus {
    border-color: #3bb77e !important;
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgba(59, 183, 126, 0.25) !important;
  }
  @media (max-width: 991px) {
    width: 100%;
  }
`;

const ErrorMsg = styled.span`
  color: #dc3545;
`;

const CustomInput = ({
  title,
  code,
  size,
  onChangeUserInputs,
  register,
  formState,
  cntError,
  cnt,
  readOnly,
}) => {
  return (
    <div className="mb-20">
      <Div>
        {code === "cnt" ? (
          <div className="w-full flex flex-col">
            <Input
              type="number"
              id={code}
              name={title}
              placeholder={title + " 입력"}
              className="form-control"
              size={size}
              onChange={onChangeUserInputs}
              value={cnt ? cnt : ""}
              readOnly={readOnly}
            />
            {readOnly && (
              <span className="text-danger">
                *아래 조건에 따라 수량이 정해지는 상품입니다.
              </span>
            )}
          </div>
        ) : (
          <Input
            type="text"
            id={code}
            name={title}
            placeholder={title + " 입력"}
            className="form-control"
            size={size}
            {...register(code, { required: "입력해주세요." })}
          />
        )}
      </Div>
      {/* {code === "cnt" ? (
        <ErrorMsg>{cntError ? cntError : ""}</ErrorMsg>
      ) : (
        <ErrorMsg>{formState?.errors[code]?.message}</ErrorMsg>
      )} */}
    </div>
  );
};
export default CustomInput;
